import fileSaver from '../../../../../helpers/download.helper'
import { AxiosService } from './../../../../../services/axios.service'
import { AdminReportsService } from '../../../../../services/admin-reports.service'
import { cardProposalsReportConstants } from './card-proposals-report.constants'
import { Creators as SiteCreators } from '../../../../../ducks/site/site'

const exportData = params => dispatch => {
	dispatch({
		type: cardProposalsReportConstants.EXPORT_DATA
	})
	dispatch(SiteCreators.showLoading())

	AxiosService.get(`${AdminReportsService.baseURL}/exportar-propostas-cartao`, {
		responseType: 'blob',
		params: params
	})
		.then(({ data }) => {
			dispatch(SiteCreators.hideLoading())
			dispatch(downloadData(data))
		})
		.catch(() => dispatch(SiteCreators.hideLoading()))
}

const downloadData = downloadData => async dispatch => {
	dispatch({
		type: cardProposalsReportConstants.DOWNLOAD_DATA
	})

	await fileSaver(downloadData, 'exportacao-de-propostas-cartao.csv')
}

export const cardProposalsReportActions = { exportData }
